// extracted by mini-css-extract-plugin
export var actionText = "_kl-4";
export var container = "_kl-0";
export var leftSection = "_kl-1";
export var rightSection = "_kl-2";
export var settingsButton = "_kl-6";
export var settingsIcon = "_kl-7";
export var shortcut = "_kl-5";
export var shortcutGroup = "_kl-3";